<div class="w-full h-full absolute top-0 left-0">
    <div class="relative top-0 left-0 h-full justify-around items-center">
        <div class="p-2" style="height: inherit">
            <div class="absolute top-0 left-0 bg-gray-800/70 w-full h-full rounded-md" [ngClass]="{
            'opacity-0': !styles.showMask,
            'opacity-1': styles.showMask
            }" ></div>
            @if(styles.showGoalPosition === 'top' || devMode){
                <div class="text-center">
                    <white-label-typography-preview class="m-auto"
                                                    [text]="data.title" [design]="styles.stylesForGoal"></white-label-typography-preview>
                </div>
            }
            @if(styles.showTotalTextPosition === 'top' && !devMode && !rerender){
                <div class="text-center">
                    <white-label-typography-preview class="m-auto"
                                                    [text]="collectedMoney | crowdfunding: data.targetValue: currency: styles.progressFormat" [design]="styles.stylesForTotalText"></white-label-typography-preview>
                </div>
            }
            <div class="relative flex m-auto h-fit items-center justify-around"
                 [ngClass]="{
                    'w-[80%]': !styles.vertical,
                    'w-[40%]': styles.vertical,
                    'flex-col-reverse': styles.vertical,
                    'flex-col': styles.vertical
                 }"
                 [ngStyle]="{
                        'background': styles.notFilledColor || '#000',
                        'min-height': styles.height + '%',
                        'border-radius': styles.borderRadius + 'px',
                        'padding': styles.border + 'px',
                        'margin': styles.vertical ? '0 auto' : 'auto'
                     }"
            >
                                    <div class="absolute z-10 justify-between px-4 h-full w-full"  [ngClass]="{
                                    'hidden': !styles.showBorderTexts || devMode,
                                    'flex': styles.showBorderTexts && !devMode,
                                    '-bottom-6 items-end px-4': !styles.vertical,
                                    'items-center flex-col-reverse top-0 py-2': styles.vertical,
                                }"
                                    >
                                        <span class="letter z-10" [ngStyle]="{
                                        'font-family': styles.stylesForTotalText?.font,
                                        'background': styles.stylesForTotalText?.color,
                                        'font-weight': 'bold',
                                        'text-decoration':  'none',
                                        'font-size': 16 + 'px',
                                        }">
                                            {{0 | currency: currency}}
                                        </span>

                                            <span class="letter" [ngStyle]="{
                                                'font-family': styles.stylesForTotalText?.font,
                                                'background': styles.stylesForTotalText?.color,
                                                'font-weight': 'bold',
                                                'text-decoration':  'none',
                                                'font-size': 16 + 'px',
                                                }">
                                            {{data.targetValue | currency: currency}}
                                        </span>
                                    </div>
                @if (styles.showTotalTextPosition === 'middle' && !devMode && !rerender) {
                    <div class="flex items-center w-full relative z-10 justify-center">
                        <white-label-typography-preview class="m-auto"
                                                        [text]="collectedMoney | crowdfunding: data.targetValue: currency: styles.progressFormat " [design]="styles.stylesForTotalText"></white-label-typography-preview>
                    </div>
                }
                @if (styles.showGoalPosition === 'middle' && !devMode) {
                    <div class="flex items-center w-full relative z-10 justify-center">
                        <white-label-typography-preview class="m-auto"
                                                        [text]="data.title" [design]="styles.stylesForGoal"></white-label-typography-preview>
                    </div>
                }
                <!-- filed progress !-->
                <div [ngStyle]="{
                        'background': styles.filledColor || 'yellow',
                        'border-radius': styles.borderRadius + 'px',
                        'width': (!styles.vertical) ? Math.min((collectedMoney / data.targetValue) * 100, 100) + '%' : '100%',
                        'height':  (styles.vertical) ? Math.min((collectedMoney / data.targetValue) * 100, 100) + '%' : '100%'
                     }" class="absolute left-0 min-w-[10%] min-h-[10%]" [ngClass]="{
                        'h-full top-0' : !styles.vertical,
                        'bottom-0' : styles.vertical
                     }">
                </div>
            </div>
            @if(styles.showGoalPosition === 'bottom' && !devMode){
                <div class="relative flex items-center w-full justify-center">
                    <white-label-typography-preview class="m-auto"
                                                    [text]="data.title" [design]="styles.stylesForGoal"></white-label-typography-preview>
                </div>
            }
            @if(styles.showTotalTextPosition === 'bottom' && !devMode && !rerender){
                <div class="flex items-center w-full relative z-10 justify-center">
                    <white-label-typography-preview class="m-auto"
                                                    [text]="collectedMoney | crowdfunding: data.targetValue: currency: styles.progressFormat" [design]="styles.stylesForTotalText"></white-label-typography-preview>
                </div>
            }
        </div>
    </div>
</div>